import React from 'react';

import { CharacterCounterField, useFormState } from '@atlaskit/form';
import type { CharacterCounterFieldProps } from '@atlaskit/form';

type SupportedElements = HTMLInputElement | HTMLTextAreaElement;

interface SnippetCharacterCounterFieldProps<
	FieldValue = string,
	Element extends SupportedElements = HTMLInputElement,
> extends Omit<CharacterCounterFieldProps<FieldValue, Element>, 'underMaximumMessage'> {
	cutoff: number;
}

/**
 * Wraps CharacterCounterField to only show the "X characters remaining"
 * message once the field value reaches the cutoff length.
 */
export function SnippetCharacterCounterField<
	FieldValue = string,
	Element extends SupportedElements = HTMLInputElement,
>({ cutoff, name, ...rest }: SnippetCharacterCounterFieldProps<FieldValue, Element>) {
	const formState = useFormState({ values: true });
	const fieldValue = String(formState?.values?.[name] ?? '');
	const underMaximumMessage = fieldValue.length >= cutoff ? undefined : '\u00A0';

	return (
		<CharacterCounterField<FieldValue, Element>
			name={name}
			underMaximumMessage={underMaximumMessage}
			{...rest}
		/>
	);
}
